var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromoEo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12996_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43359 0.273438L12.9062 3.80078C14.3555 5.25 14.3555 7.57422 12.9062 9.02344L9.84375 12.1133C9.59766 12.3867 9.1875 12.3867 8.91406 12.1406C8.66797 11.8672 8.66797 11.457 8.91406 11.2109L11.9766 8.09375C12.9062 7.16406 12.9062 5.66016 11.9766 4.73047L8.47656 1.17578C8.23047 0.929688 8.23047 0.519531 8.50391 0.246094C8.75 0 9.16016 0 9.43359 0.273438ZM0 5.46875V1.36719C0 0.65625 0.574219 0.0546875 1.3125 0.0546875H5.38672C5.85156 0.0546875 6.28906 0.246094 6.61719 0.574219L11.2109 5.16797C11.8945 5.85156 11.8945 6.97266 11.2109 7.65625L7.57422 11.293C6.89062 11.9766 5.76953 11.9766 5.08594 11.293L0.492188 6.69922C0.164062 6.37109 0 5.93359 0 5.46875ZM3.9375 3.11719C3.9375 2.65234 3.52734 2.24219 3.0625 2.24219C2.57031 2.24219 2.1875 2.65234 2.1875 3.11719C2.1875 3.60938 2.57031 3.99219 3.0625 3.99219C3.52734 3.99219 3.9375 3.60938 3.9375 3.11719Z",
    fill: "black",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12996_189",
    x: 0,
    y: 0,
    width: 14.3555,
    height: 13.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12996_189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12996_189",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoEo);
export default ForwardRef;